import { render, staticRenderFns } from "./configuration-automation-grossing-shelf-sample-type-and-shelf-grid.vue?vue&type=template&id=30490b6f&scoped=true&"
import script from "./configuration-automation-grossing-shelf-sample-type-and-shelf-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-grossing-shelf-sample-type-and-shelf-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-grossing-shelf-sample-type-and-shelf-grid.scss?vue&type=style&index=0&id=30490b6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30490b6f",
  null
  
)

export default component.exports